import React from 'react';

interface RoomNumberOrNameProps {
  residentFullName: string;
  roomNumberOrName: string;
  setRoomNumberOrName: (value: string) => void;
}

const RoomNumberOrName: React.FC<RoomNumberOrNameProps> = ({
  residentFullName,
  roomNumberOrName,
  setRoomNumberOrName,
}) => {
  return (
    <div className="govuk-form-group mt-2 govuk-bp:mt-5">
      <h1 className="govuk-label-wrapper">
        <label
          className="govuk-label govuk-label--l"
          htmlFor="roomNumberOrName"
        >
          Room number or name
        </label>
      </h1>
      <div id="room-number-or-name-hint" className="govuk-hint">
        If {residentFullName} resides within your care home, hospice or care
        setting please enter their room number or name below.
      </div>
      <input
        className="govuk-input govuk-input--width-20"
        id="roomNumberOrName"
        name="roomNumberOrName"
        type="text"
        autoComplete="roomNumberOrName"
        aria-describedby="room-number-or-name-hint"
        placeholder="Enter room name or number"
        value={roomNumberOrName}
        onChange={e => setRoomNumberOrName(e.target.value)}
      />
    </div>
  );
};

export default RoomNumberOrName;
